<template>
    <DxLoadPanel :position="position" class="lgi-loadpanel"
                 v-model:visible="loadingVisible"
                 :show-indicator="true"
                 :copy-root-classes-to-wrapper="true"
                 :show-pane="true"
                 :shading="true"
                 :width="150"
                 message="Please wait ..."
                 shading-color="rgba(0,0,0,0.4)" />
    <div class="lgi">
        <form @submit="onFormSubmit" action="xx">
            <div class="resp-form">
                <div class="lgi-header">
                    <div @click="toLandingPage()" class="pq4-logo">
                    </div>
                    <div class="lgi-welcome">
                        Reset Password
                    </div>
                    <div class="lgi-welcome-text">
                        Enter your Email an we'll send you a link to reset yor password
                    </div>
                </div>
                <div class="field">
                    <div class="dx-email-value">
                        <DxTextBox v-model:value="userName"
                                   :show-clear-button="false"
                                   mode="name"
                                   label="Email"
                                   label-mode="static"
                                   placeholder="Enter email">
                            <DxValidator>
                                <DxRequiredRule message="Email is required" />
                                <DxEmailRule message="Email is invalid" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="field" v-if="true">
                    <div>
                        <img :src="captchaImage" class="captcha-img" />
                        <DxButton icon="refresh" @click="refreshCaptcha" />
                    </div>
                    <div class="reg-captcha">
                        <DxTextBox v-model:value="captcha.captchaCode"
                                   :show-clear-button="false"
                                   label="Type the Code"
                                   label-mode="static">
                            <DxValidator>
                                <DxRequiredRule message="Captcha code is missing" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="lgi-err-msg" v-if="hasMessage">
                    {{ errorMessage }}
                </div>
                <div class="lgi-btns">
                    <DxButton class="resetBtn"
                              text="Reset Password"
                              type="success"
                              :use-submit-behavior="true" />

                </div>
            </div>
        </form>
    </div>
    <div class="res-pass-footer">
        <div class="res-back-btn pq4-link" @click="backToLogin()">Back to login</div>
    </div>
    <FooterSmall></FooterSmall>
</template>
<script>
    import { DxButton } from 'devextreme-vue/button';
    import DxLoadPanel from 'devextreme-vue/load-panel';
    import DxTextBox from 'devextreme-vue/text-box';
    import FooterSmall from './widgets/FooterSmall.vue'; import {
        DxValidator,
        DxRequiredRule,
        DxEmailRule,
        //DxPatternRule,
        //DxStringLengthRule,
        //DxRangeRule,
        //DxAsyncRule,
    } from 'devextreme-vue/validator';
    import { alert } from "devextreme/ui/dialog"


    const resetStateEnum = {
        None: 0,
        Success: 1,
        WrongCaptcha: 2,
        AccountNotFound: 3
    }
    export default {

        name: 'LoginPage',
        components: {
            DxButton,
            DxTextBox,
            DxLoadPanel,
            DxValidator,
            DxRequiredRule,
            DxEmailRule,
            FooterSmall
        },
        data() {
            return {
                loadingVisible: false,
                userName: "",
                password: "",
                captchaCode: "",
                errorMessage: "",
                showPasswordReset: false
            }
        },
        mounted() {
            this.$store.dispatch("getCaptcha")
        },
        created: function () {


        },
        computed: {
            hasMessage() {
                return this.errorMessage && this.errorMessage.length > 0
            },
            captcha() {
                return this.$store.state.registrationStore.captcha
            },
            captchaImage() {
                return this.$store.state.registrationStore.captchaImage
            },
            captchaLoaded() {
                return this.$store.state.registrationStore.captchaLoaded;
            },
            resetState() {
                return this.$store.state.registrationStore.resetState;
            },
        },
        methods: {
            toLandingPage() {
                window.location.href = "../landingPage.aspx"
            },
            backToLogin() {
                window.location.href = "../Login.aspx"
            },
            resetPassword() {
                this.$store.dispatch("resetPassword", { userName: this.userName })
            },
            refreshCaptcha() {
                this.$store.dispatch("getCaptcha")
            },
            onFormSubmit(e) {
                this.resetPassword();
                e.preventDefault();
            },
        },
        watch: {
            resetState(newStatus) {
                switch (newStatus) {
                    case resetStateEnum.Success:
                        alert(`You have successfully reset your password. An email message with <br/>
                            a password reset link was sent to the address you provided.`,
                            "Password Reset").then(() => {
                                window.location.href = '../Login.aspx'
                            })
                        break
                    case resetStateEnum.WrongCaptcha:
                        this.$store.dispatch("getCaptcha")
                        alert(`Wrong captcha code`, "Password Reset")
                        break;
                    case resetStateEnum.AccountNotFound:
                        this.$store.dispatch("getCaptcha")
                        alert(`No account was found with this email address`, "Password Reset")
                        break;
                    default:
                        this.$store.dispatch("getCaptcha")
                        alert(`An error occured`, "Password Reset")
                        break;
                }
            }
        },
    }
</script>
<style>
    .res-back-btn {
        color: #304897;
        font-size: 12px;
        font-weight: bold;
    }

    .res-pass-footer {
        display: flex;
        justify-content: center;
    }

    .lgi .field {
        display: flex;
        flex-direction: column;
        padding: 10px 0px 10px 0px;
    }

    .lgi .lgi-err-msg {
        color: red;
        font-size: 12px;
    }

    .lgi .lgi-btns {
        display: flex;
        flex-direction: column;
        padding: 0 0px 10px 0px;
    }

    .lgi div#summary {
        margin-bottom: 10px;
    }


    .lgi .lgi-btns {
        margin-top: 10px;
        text-align: center;
    }

    .lgi .dx-pass-value, .lgi .dx-email-value {
    }


    .lgi-loadpanel .dx-loadpanel-indicator.dx-loadindicator.dx-widget {
        margin: auto;
        display: block;
    }

    .lgi-welcome-text {
        font-size: 15px;
        text-align: center;
        margin-bottom: 5px;
    }

    .lgi-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .lgi-footer-text {
        font-size: 12px;
    }

    .lgi .lgi-sign-btn {
        color: #f65923;
        font-size: 12px;
        font-weight: bold;
    }

    .lgi .lgi-reset-btn.pq4-link {
        font-size: 11px;
        text-align: right;
        color: #7d7c84;
    }
</style>